/*
 * !!!!!!!!!!!!!!!!!!!!!!!
 * This service should only be injected into app.component.ts
 * !!!!!!!!!!!!!!!!!!!!!!!
 *
 * Manages user impersonation and access data.
 */

import { Injectable } from '@angular/core';
import { ImpersonationService } from './impersonation.service';
import { ToastService } from './toast.service';
import { UserAccessService } from './user-access.service';
import { Router } from '@angular/router';
import { LimegearAuthenticationService } from '../../login/services/limegear-authentication.service';
import { CurrentUserStateService } from './current-user-state.service';

@Injectable({
    providedIn: 'root',
})
export class UserManagementService {
    constructor(
        public impersonationService: ImpersonationService,
        public toastService: ToastService,
        private accessService: UserAccessService,
        private router: Router,
        private currentUserStateService: CurrentUserStateService
    ) {
        // Subscribe to value of impersonation
        this.impersonationService.impersonatingUserSubject.subscribe((data) => {
            // Call action if value updates
            if (data) {
                this.accessService.setAccess(true);
            }
        });

        this.impersonationService.impersonatingClientSubject.subscribe((data) => {
            // Call action if value updates
            if (data && this.currentUserStateService.isPlatformUser()) {
                this.accessService.setAccess(true);
            }
        });

        // Subscribe to see when it's time to end impersonation
        this.toastService.stopImpersonationSubject.subscribe((data) => {
            if (data) {
                this.impersonationStop();
            }
        });

        // Reload page when data access has been modified
        this.accessService.dataUpdatedSubject.subscribe((data) => {
            if (data && data.valueChanged && data.shouldReloadPage) {
                // Reload current page/component
                const pageName = location.pathname.slice(1);
                this.router.navigate(['']).then(() => {
                    this.router.navigate([pageName]);
                });
            }
        });
    }

    public init() {
        this.impersonationService.initImpersonation();
        let impersonateUser = localStorage.getItem('impersonateUser');
        if (impersonateUser && !this.impersonationService.isImpersonatingUser()) {
            this.impersonationStart(impersonateUser, '', true);
        } else {
            this.accessService.setAccess(false);
        }
    }

    // Handle UI behavior and state for starting impersonation
    public impersonationStart(email, name, refresh = false) {
        // Begin Impersonation
        this.impersonationService.startImpersonatingUser(email, refresh);

        // Display toast informing user
        this.toastService.info(`Viewing as ${email}`, {
            dismiss: true,
            timeout: 0,
            actionText: 'End',
            logic: 'impersonation',
        });
    }

    // Handle UI behavior and state for stopping impersonation
    public impersonationStop() {
        this.impersonationService.stopImpersonatingUser();
        this.accessService.setAccess();
    }

    public get impersonationStatus() {
        return this.impersonationService.impersonatingUserSubject.value;
    }

    public setLoggedIn() {
        this.accessService.setAccess();
    }
}
